import gallery1 from "../../assets/banners/gallery1.jpg";
import gallery2 from "../../assets/banners/gallery2.jpg";
import gallery3 from "../../assets/banners/gallery3.jpg";
import gallery4 from "../../assets/banners/gallery4.jpg";
import gallery5 from "../../assets/banners/gallery5.jpg";
import gallery6 from "../../assets/banners/gallery6.jpg";
import gallery7 from "../../assets/banners/gallery7.jpg";
import gallery8 from "../../assets/banners/gallery8.jpg";
import gallery9 from "../../assets/banners/gallery9.jpg";

export const gallery_utils = [
  { img: gallery1, title: "", desc: "" },
  { img: gallery2, title: "", desc: "" },
  { img: gallery3, title: "", desc: "" },
  { img: gallery4, title: "", desc: "" },
  { img: gallery5, title: "", desc: "" },
  { img: gallery6, title: "", desc: "" },
  { img: gallery7, title: "", desc: "" },
  { img: gallery8, title: "", desc: "" },
  { img: gallery9, title: "", desc: "" },
];
